var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSqlWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;strokeMiterlimit:10;strokeWidth:1.25px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sql") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "techSkills_Logos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SQL"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 31.5,
    cy: 13.26,
    rx: 19.91,
    ry: 6.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.41,24.86c0,3.73-8.91,6.76-19.91,6.76s-19.91-3-19.91-6.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.41,36.07c0,3.73-8.91,6.76-19.91,6.76s-19.91-3-19.91-6.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.59,13.06V47.28C11.59,51,20.5,54,31.5,54s19.91-3,19.91-6.76V13.06"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlWhite);
export default __webpack_public_path__ + "static/media/sql_white.95abdeb2a8e98e3c1584c4a50c6200ab.svg";
export { ForwardRef as ReactComponent };